import PropTypes from 'prop-types';

function QuizNavigation({ length, currentQuestion, answers, handleNext }) {
    const isAnswered = answers[`q${currentQuestion}`] !== undefined;
    const isLastQuestion = currentQuestion === length - 1;
    const buttonText = (!isLastQuestion) ? 'Continuer' : 'Voir le résultat';

    return <button className="button button--light button--icon button--arrow" data-key="confirm" onClick={handleNext} disabled={!isAnswered}><span>{buttonText}</span></button>
}

QuizNavigation.propTypes = {
    length: PropTypes.number.isRequired,
    currentQuestion: PropTypes.number.isRequired,
    answers: PropTypes.object.isRequired,
    handleNext: PropTypes.func.isRequired,
}

export default QuizNavigation;
